import AboutHeader from "@/components/AboutHeader";
import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import LayoutFooter, { getFooterDataSource } from "@/components/LayoutFooter";
import useAppStore from "@/context/store";
import GoodiesCarousel from "@/pageComponents/Goodies/GoodiesCarousel";
import PluginButton from "@/pageComponents/Goodies/PluginButton";
import { cacheor } from "@/utils/server/cacheor";
import { useEventListener, useInViewport, useMount, useSize } from "ahooks";
import classNames from "classnames";
import Head from "next/head";
import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.less";

const descList = [
  {
    desc: "海量图片存入云端，不占本地内存",
    icon: "cloud",
  },
  {
    desc: "登录花瓣就能查看所有灵感，无须携带硬盘",
    icon: "pc",
  },
  {
    desc: "分享链接就可以和同事朋友共享你的灵感",
    icon: "share",
  },
];
const IType = {
  NOTNEW: "0",
  ISNEW: "1",
};
export default function Goodies(props) {
  const {
    banner,
    galleryList,
    descImg,
    footerImg,
    introList,
    pluginList,
    version,
    problemHref,
    footerDataSource,
  } = props;
  const { headerHeight } = useAppStore(({ headerHeight }) => ({
    headerHeight,
  }));

  const [className, setClassName] = useState("leftTop");
  const [domArr, setDom] = useState([]);
  const [videoDom, setVideoDom] = useState([]);
  const [activeKey, setActiveKey] = useState(0);
  const introRef = useRef(null);
  const flagRef = useRef(null);
  const [inViewport] = useInViewport(flagRef);
  const bodySize = useSize(() => document.querySelector("body"));
  useEffect(() => {
    chooseClassName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [introRef, inViewport, headerHeight]);

  useEventListener("scroll", () => {
    // 左侧模块根据不同的滚动状态添加类名
    chooseClassName();
    setActive();
  });

  const chooseClassName = () => {
    // 判断该模块是否到顶部
    if (
      introRef.current?.getBoundingClientRect().top - headerHeight < 0 &&
      inViewport === false
    ) {
      setClassName("leftCenter");
      // 该模块已经滚动完了
    } else if (
      introRef.current?.getBoundingClientRect().top - headerHeight < 0 &&
      inViewport
    ) {
      setClassName("leftBottom");
    } else {
      // 该模块还未滚动到
      setClassName("leftTop");
    }
  };
  // useEffect(() => {
  //   setPackage(checkBrowser(pluginList, navigator));
  // }, [pluginList]);
  useEffect(() => {
    if (videoDom.length) {
      // 切换视频重播
      videoDom[activeKey].currentTime = 0;
      videoDom[activeKey].load();
      setTimeout(() => {
        const playPromise = videoDom[activeKey].play();
        if (playPromise) {
          // 解决决报错问题 The play() request was interrupted because video-only background media was paused to save power.
          playPromise.then(() => {}).catch(() => {});
        }
      }, 200);
    }
  }, [activeKey, videoDom]);
  useMount(() => {
    let domArr = document.querySelectorAll(`.${styles.descContent}`);
    let videoArr = document.querySelectorAll(`.${styles.video}`);
    setDom(domArr);
    setVideoDom(videoArr);
  });
  const setActive = () => {
    domArr.forEach((i, index) => {
      let top = i?.getBoundingClientRect().top;
      if (
        top <
          (bodySize?.height - headerHeight) / 2 +
            (bodySize?.height - headerHeight) / 2 &&
        top >
          (bodySize?.height - headerHeight) / 2 -
            (bodySize?.height - headerHeight) / 4
      ) {
        i.classList.add(styles.introRightActive);
        setActiveKey(index);
      } else {
        i.classList.remove(styles.introRightActive);
      }
    });
  };
  useEffect(() => {
    setActive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domArr, bodySize, headerHeight, introList]);
  // const download = (e) => {
  //   const { href } = installPackage;
  //   e.preventDefault();
  //   console.log(e);
  //   button_click(e.target, navigator.userAgent);
  //   if (!href?.length) {
  //     HBMessage.error("当前浏览器暂未支持，请使用其他浏览器下载");
  //     return;
  //   }
  //   window.location.href = href[0].url;
  // };

  const leftStyle = useMemo(() => {
    if (className === "leftTop") {
      return `translateY(-${headerHeight / 2}px)`;
    } else if (className === "leftBottom") {
      return `translateY(${headerHeight / 2}px)`;
    } else {
      return `translateY(${headerHeight / 2}px)`;
    }
  }, [className, headerHeight]);
  return (
    <div className={styles.goodies}>
      <Head>
        <title>花瓣采集工具-花瓣</title>
        <meta
          name="description"
          content="用花瓣网收集和分享你喜欢的一切。使用花瓣网采集工具，你可以方便保存任意网页上的图片、视频或视频和截图。"
        ></meta>
        <meta
          name="keywords"
          content="花瓣采集插件,采集工具,图片采集,浏览器采集插件"
        ></meta>
      </Head>
      <AboutHeader />

      <div
        className={styles.banner}
        style={{ backgroundImage: `url(${banner[0].url})` }}
      >
        <div className={styles.left}>
          <div className={styles.content}>
            <h1 className={styles.title}>
              花瓣采集插件 <br></br>高效收藏网页图片{" "}
              <span className={styles.newIcon}>新版</span>
            </h1>
            {/* <div className={styles.title}></div> */}
            <div className={styles.subtitle}>
              提供多种采集和截图方式，帮你将网页图片快速采集到花瓣上，让你的灵感收集更高效。
            </div>
            <div className={styles.action}>
              <PluginButton pluginList={pluginList} problemHref={problemHref} />
            </div>
            <div className={styles.linkContent}>
              {/* <a
                className={styles.link}
                // target="_blank"
                href={!!installPackage?.href ? installPackage.href[0]?.url : ""}
                onClick={(e) => {
                  download(e);
                }}
              >
                <HBIcon className={styles.icon} type="ic_download1" />
                <div className={styles.text} data-button-name={`${installPackage?.title}安装包`}>
                  离线下载安装包
                </div>
              </a> */}
              {/* <a
                className={styles.link}
                target="_blank"
                href="//support.qq.com/products/30852/faqs/108940"
                rel="noreferrer"
              >
                <HBIcon className={styles.icon} type="ic_help" />
                <div className={styles.text}>安装&使用教程</div>
              </a> */}
              <span className={styles.link}>版本号 {version}</span>
            </div>
          </div>
        </div>
        <div className={styles.right}></div>
      </div>
      <div
        className={`${styles.introContent} ${
          styles[`background-${activeKey}`]
        }`}
        ref={introRef}
      >
        <div className={styles.introLeft}>
          <div
            className={classNames([styles.videoContent, styles[className]])}
            style={{
              transform: `${leftStyle}`,
            }}
          >
            {introList.map((i, index) => {
              return (
                <video
                  className={classNames([
                    styles.video,
                    index === activeKey ? styles.videoActive : "",
                  ])}
                  key={index}
                  autoPlay
                  muted
                  loop
                  preload="metadata"
                  src={i.video[0].url}
                />
              );
            })}
            {/* 固定描述文案 */}
            {/* <div className={styles.fixedDesc} style={{top:`calc(((100vh - ${headerHeight}px) / -4 + 90px))`}}>
              <header>快速采集网页图片</header>
              <div>浏览任意网页时，想要保存它们，用花瓣采集插件，3种收藏方式，喜欢哪种用哪种。</div>
            </div> */}
            {/* 滚动操作栏 */}
            <aside className={styles.control}>
              {introList.map((i, index) => {
                return (
                  <a
                    href={`#goodies-intro-${index}`}
                    key={index}
                    // onClick={() => roll(index)}
                    className={index === activeKey ? styles.activeIcon : ""}
                  >
                    <HBIcon
                      type={i.icon}
                      className={styles.controlIcon}
                    ></HBIcon>
                  </a>
                );
              })}
            </aside>
          </div>
        </div>
        <div className={styles.introRight}>
          {introList.map((i, index) => {
            return (
              <div
                className={styles.introRightContent}
                key={i.title}
                id={`goodies-intro-${index}`}
              >
                <div className={styles.descContent}>
                  <header>
                    <span>
                      {i.title}
                      {i.type === IType.ISNEW && (
                        <span className={styles.newIcon}>NEW</span>
                      )}
                    </span>
                  </header>
                  <p>{i.subTitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div ref={flagRef}>
        {galleryList.map((item, index) => (
          <GoodiesCarousel key={index} data={item}></GoodiesCarousel>
        ))}
        <div className={styles.introduceContent}>
          <div className={styles.introduceLeft}>
            <Image width={560} height={400} src={descImg[0].url} alt=""></Image>
          </div>
          <div className={styles.introduceRight}>
            <header>通过插件采集灵感，可存储云端&实现多设备同步</header>
            {descList.map((i) => {
              return (
                <div className={styles.introduceDesc} key={i.desc}>
                  <HBIcon
                    style={{ paddingRight: "12px" }}
                    type={i.icon}
                  ></HBIcon>
                  {i.desc}
                </div>
              );
            })}
          </div>
        </div>

        <div
          className={styles.bannerFooter}
          style={{ backgroundImage: `url(${footerImg[0].url})` }}
        >
          <header>下载采集插件，开启高效收藏之旅</header>
          <PluginButton pluginList={pluginList} problemHref={problemHref} />
        </div>
        <LayoutFooter dataSource={footerDataSource} />
      </div>
    </div>
  );
}

export async function getServerSideProps({ req, query }) {
  let data = await cacheor.getGrocery({
    path: "hb-plugin-extension",
    disableCache: query?._cache,
  });

  const dataSource = await getFooterDataSource({
    query,
    seoLinkInfo: {
      currentUrl: req.url,
    },
  });

  return {
    props: {
      ...data,
      footerDataSource: dataSource,
    },
  };
}
